import { createGlobalStyle, css } from 'styled-components';

const FeedbackPopupStyle = createGlobalStyle`${css`
	:root {
		--feedbackPopupBlockPadding: 0 var(--sp18x);
		--feedbackTitleDistance: var(--sp4x);
		--feedbackBtnDistance: var(--sp8x) 0;
		--feedbackSuccessPadTB: var(--sp25x);
		--cSuccessPanelSizes: var(--sp7x);
		--cSuccessPanelMarginRight: var(--sp4x);
		--cSuccessIconSize: var(--sp3x);
	}

	.success-message {
		margin-top: var(--sp1x);
	}

	.ant-form {
		margin-top: var(--feedbackTitleDistance);
	}

	.feedback-content-wrap {
		padding: var(--feedbackPopupBlockPadding);
		margin: 0 auto;
	}

	textarea {
		resize: none;

		&::-webkit-scrollbar {
			display: none;
		}
	}

	.ant-input-textarea-suffix {
		display: none;
	}

	.feedback-button-block {
		display: flex;
		justify-content: flex-end;
		margin: var(--feedbackBtnDistance);
	}

	.feedback-btn {
		font-size: var(--pS);
	}

	.success-container {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: var(--feedbackSuccessPadTB) 0;
		padding-top: calc(var(--feedbackSuccessPadTB) - var(--closeButtonSizes));
		text-align: left;
	}

	.success-panel {
		min-width: var(--cSuccessPanelSizes);
		min-height: var(--cSuccessPanelSizes);
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: var(--cSuccessPanelMarginRight);
		background-color: var(--successColor);
		clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
	}

	.success-icon {
		color: var(--primaryColor3);
		font-size: var(--cSuccessIconSize);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		:root {
			--feedbackBtnDistance: var(--sp6x) 0;
			--feedbackTitleDistance: var(--sp4x);
			--feedbackPopupBlockPadding: 0 var(--sp12x);
			--feedbackSuccessPadTB: var(--sp20x);
			--cSuccessPanelSizes: var(--sp7x);
			--cSuccessPanelMarginRight: var(--sp3x);
			--cSuccessIconSize: var(--sp3x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		:root {
			--feedbackBtnDistance: var(--sp5x) 0;
			--feedbackTitleDistance: var(--sp3x);
			--feedbackPopupBlockPadding: 0 var(--sp10x);
			--feedbackSuccessPadTB: var(--sp20x);
			--cSuccessPanelSizes: var(--sp5x);
			--cSuccessPanelMarginRight: var(--sp3x);
			--cSuccessIconSize: var(--sp2x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		:root {
			--feedbackBtnDistance: var(--sp5x) 0;
			--feedbackTitleDistance: var(--sp3x);
			--feedbackPopupBlockPadding: 0 var(--sp10x);
			--feedbackSuccessPadTB: var(--sp10x);
			--cSuccessPanelSizes: var(--sp5x);
			--cSuccessPanelMarginRight: var(--sp3x);
			--cSuccessIconSize: var(--sp2x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		:root {
			--feedbackBtnDistance: var(--sp5x) 0;
			--feedbackTitleDistance: var(--sp3x);
			--feedbackPopupBlockPadding: 0 var(--sp7x);
			--feedbackSuccessPadTB: var(--sp10x);
			--cSuccessPanelSizes: var(--sp5x);
			--cSuccessPanelMarginRight: var(--sp3x);
			--cSuccessIconSize: var(--sp2x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		:root {
			--feedbackBtnDistance: var(--sp4x) 0;
			--feedbackTitleDistance: var(--sp3x);
			--feedbackPopupBlockPadding: 0 var(--sp5x);
			--feedbackSuccessPadTB: var(--sp10x);
			--cSuccessPanelSizes: var(--sp5x);
			--cSuccessPanelMarginRight: var(--sp2x);
			--cSuccessIconSize: var(--sp2x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		:root {
			--feedbackBtnDistance: var(--sp4x) 0;
			--feedbackTitleDistance: var(--sp3x);
			--feedbackPopupBlockPadding: 0 var(--sp5x);
			--feedbackSuccessPadTB: var(--sp10x);
			--cSuccessPanelSizes: var(--sp5x);
			--cSuccessPanelMarginRight: var(--sp2x);
			--cSuccessIconSize: var(--sp2x);
		}
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		:root {
			--feedbackBtnDistance: var(--sp4x) 0;
			--feedbackTitleDistance: var(--sp3x);
			--feedbackPopupBlockPadding: 0;
			--feedbackSuccessPadTB: var(--sp10x);
			--cSuccessPanelSizes: var(--sp5x);
			--cSuccessPanelMarginRight: var(--sp2x);
			--cSuccessIconSize: var(--sp2x);
		}

		.popup-content-container {
			max-width: calc(100% - var(--sp4x)) !important;
		}
	}
`}`;

export default FeedbackPopupStyle;
